import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { hotlineLpSpeechBubbleStyle } from '@/feature/hotline/lp/component/HotlineLpSpeechBubble/style';
/**
 * ホットライン LP 用の吹き出し
 */
export const HotlineLpSpeechBubble = (props) => {
    const { children, className = '', tagName: Tag = 'div', variants } = props;
    const style = hotlineLpSpeechBubbleStyle(variants);
    return _jsx(Tag, Object.assign({ className: style.base({ class: className }) }, { children: children }));
};
